import { nextReduxWrapper } from '../../src/client/store/create-store';
import DownloadsPage from '../../src/client/pages/downloads';
import fetchAllProductData from '../../src/client/models/product/fetch-all-product-data';

export const getServerSideProps = nextReduxWrapper.getServerSideProps((store) => async () => {
  await fetchAllProductData(store.getState(), store.dispatch);
  return { props: {} };
});

export default DownloadsPage;
